import type { Timestamp } from '@bufbuild/protobuf/wkt'

import type { IntradayBidRow } from '~/pages/IntradayBidding/models/intradayBidRow'

/**
 * 札をまとめて操作する RPC (一括板取消 AC-BIN-112・入札を全削除 AC-BIN-138) に送る対象 1 札。
 * `expectedUpdatedAt` は一覧の値を Timestamp のまま渡す (Date に変換すると µs を落として照合に
 * 外れる。 `frontend-time.md`)。
 */
export type IntradayBulkRequestTarget = {
  id: string
  expectedUpdatedAt: Timestamp | undefined
}

export function intradayBulkRequestTargets(
  targets: readonly IntradayBidRow[],
): IntradayBulkRequestTarget[] {
  return targets.map((bid) => ({
    id: bid.id,
    expectedUpdatedAt: bid.updatedAt,
  }))
}
